/**
 * InviteParentControl
 */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import IconButton from 'components/interaction/IconButton/index.jsx';
import InviteParentModal from './InviteParentModal.jsx';

function InviteParentControl(props) {
  const { user, ...rest } = props;
  const [show, setShow] = useState(false);
  return (
    <>
      <IconButton icon="ss-plus" onClick={() => setShow(true)} {...rest} />
      <InviteParentModal user={show ? user : null} onHide={() => setShow(false)} />
    </>
  );
}

InviteParentControl.propTypes = {
  user: PropTypes.object,
};

export default InviteParentControl;
